import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';

const ModalCadastros = ({ children, loading, ...otherProps }) => (
  <Modal
    okText="Gravar"
    cancelText="Fechar"
    closable={false}
    confirmLoading={loading}
    cancelButtonProps={{ disabled: loading }}
    {...otherProps}
  >
    {children}
  </Modal>
);

ModalCadastros.propTypes = {
  children: PropTypes.element.isRequired,
  loading: PropTypes.bool,
  visible: PropTypes.bool.isRequired,
};

ModalCadastros.defaultProps = {
  loading: false,
};

export default ModalCadastros;
